import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import loadable from "../loadable";
const AdminMenu = loadable(() => import("./AdminMenu"));

const user = JSON.parse(localStorage.getItem('user'));

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        localStorage.getItem('user') && props.match
            ? props.match.path.toString().substr(0, 6) === '/admin' ? 
                <React.Fragment>
                    <AdminMenu user={user}/>
                    <Component {...props} />
                </React.Fragment>
                : <Component {...props} /> 
            : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />
)